exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Header {\n  width: 100vw;\n  min-width: 360px;\n  min-height: 60px;\n  display: -ms-flexbox;\n  display: flex;\n  position: fixed;\n  top: 0;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  z-index: 1;\n  color: #2f373d;\n  background-color: rgba(255, 255, 255, 0.9);\n  border-bottom: 1px solid #ebebeb; }\n  .Header-ButtonsWrapper {\n    position: absolute;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: end;\n        justify-content: flex-end;\n    width: 100vw;\n    min-width: 360px;\n    padding: 0 50px;\n    box-sizing: border-box; }\n", ""]);

// exports
